import { Filmomtale } from '@filmweb/sanity-types';
import SMaxWidthContainer from 'components/framework/SMaxWidthContainer';
import { IMovieArticle } from 'lib/types/sanity';

import styles from "./Oneliner.module.css";


//#region [Props]
type OnelinerProps = {
    document?: IMovieArticle | null;
    filmomtale?: Filmomtale | null;
};
//#endregion

//#region [Component]
export default function Oneliner({ filmomtale, document }: OnelinerProps) {
    const oneliner = document?.oneliner?.trim() ?? filmomtale?.oneliner?.trim();
    if (!oneliner) {
        return null;
    }
    return <SMaxWidthContainer className={styles.Oneliner} $forContent>
        {oneliner}
    </SMaxWidthContainer>;
}
//#endregion